import { useMutation } from "@tanstack/react-query";
import notificationService from "..";

function useUpdateReadMessage() {
  return useMutation({
    mutationFn: notificationService.sendReadNotification,
  });
}

export default useUpdateReadMessage;
